import React, { useEffect, useRef } from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom";
import $ from "jquery";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const LinkButton = (props) => {
    const buttonRef = useRef();

    useEffect(() => {
        return () => $(buttonRef.current).tooltip("dispose");
    }, []);

    let marge = (props.icon && props.label) ? { marginRight: ".50rem" } : { marginRight: "0" };

    return (
        <Link to={props.to} className="text-decoration-none">
            <button
                ref={buttonRef}
                type="button"
                className={"btn " + props.className}
                data-tooltip
                title={props.tooltipTitle}
            >
                {props.icon &&
                    <FontAwesomeIcon
                        icon={props.icon}
                        style={marge}
                    />
                }
                {props.label}
            </button>
        </Link>
    );
}

LinkButton.defaultProps = {
    label: null,
    className: "",
    tooltipTitle: "",
}

LinkButton.propTypes = {
    to: PropTypes.string.isRequired,
    label: PropTypes.string,
    icon: PropTypes.object,
    className: PropTypes.string,
    tooltipTitle: PropTypes.string
};

export default LinkButton